import { Expose } from "@nts/std/serialization";
import { AccessMode } from './access-mode.enum';

export class UserMetaData {

    @Expose()
    securityAccess?: AccessMode;

}
